import React from "react";
import { Link } from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import {
  serviceLevels,
  evaluatePrice,
  contactEmail,
  currencyCaption,
  evaluateSlabPrice,
} from "../enums";

const numberWithCommas = (x) =>
  x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

const useStyles = makeStyles((theme) => ({
  red: {
    color: "red",
    textTransform: "uppercase",
  },
  title: {
    paddingTop: theme.spacing() * 2,
    marginBottom: theme.spacing() * 2,
  },
  titleSmall: {
    marginBottom: theme.spacing() * 1.5,
  },
  gridItem: {
    marginBottom: theme.spacing() * 3,
  },
  subSection: {
    marginBottom: theme.spacing() * 3,
  },
  serviceLogo: {
    maxHeight: 50,
    maxWidth: 50,
    verticalAlign: "middle",
  },
  serviceDescription: {
    display: "inline-block",
    verticalAlign: "middle",
    marginLeft: theme.spacing() * 1.5,
    "& > h6": {
      lineHeight: 0.5,
    },
  },
  smallFont: {
    fontSize: "small",
  },
  smallCenter: {
    fontSize: "small",
    textAlign: "center",
  },
}));

export default () => {
  const classes = useStyles();

  return (
    <>
      <Typography variant="h5" className={classes.title}>
        Turnaround Times
      </Typography>
      <Typography variant="body1" className={classes.subSection}>
        <Link to="/evaluate">Evaluation</Link> starting at {currencyCaption}
        {evaluatePrice} per raw card and {currencyCaption}
        {evaluateSlabPrice} per slabbed card. Shipping and Shipping Insurance
        (offered and recommended but not required) to be discussed and agreed
        upon by Gem Mint Submissions prior to submitting any card to grading
        companies. Questions? Email us at{" "}
        <a href={`mailto:${contactEmail}`}>{contactEmail}</a>
      </Typography>
      <Grid container alignItems="top" justify="space-around">
        {Object.values(serviceLevels).map((serviceLevel, index) => (
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            lg={3}
            className={classes.gridItem}
            key={index}
          >
            {/* eslint-disable-next-line */}
            <img className={classes.serviceLogo} src={serviceLevel.logo} />
            <div className={classes.serviceDescription}>
              <Typography variant="h6">{serviceLevel.label}</Typography>
              <br />
              <Typography component="span">
                {serviceLevel.lowPrice ? (
                  <>
                    {currencyCaption}
                    {serviceLevel.lowPrice.toFixed(2)} - {currencyCaption}
                    {serviceLevel.price.toFixed(2)} / card
                  </>
                ) : (
                  <>
                    {currencyCaption}
                    {serviceLevel.price.toFixed(2)} / card
                  </>
                )}
              </Typography>
              <br />
              <Typography component="span">
                {serviceLevel.turnaroundTime}
              </Typography>
              {serviceLevel.description ? (
                <>
                  <br />
                  <Typography component="span" className={classes.smallFont}>
                    {serviceLevel.description}
                  </Typography>
                </>
              ) : null}
              {serviceLevel.maxDeclaredValue ? (
                <>
                  <br />
                  <Typography component="span" className={classes.smallFont}>
                    {currencyCaption}
                    {numberWithCommas(serviceLevel.maxDeclaredValue)} Max
                    Declared Value
                  </Typography>
                </>
              ) : null}
              {serviceLevel.cardMinimum ? (
                <>
                  <br />
                  <Typography component="span" className={classes.smallFont}>
                    {serviceLevel.cardMinimum} Card Minimum
                  </Typography>
                </>
              ) : null}
            </div>
          </Grid>
        ))}
      </Grid>
      <Typography
        variant="subtitle1"
        color="textSecondary"
        className={classes.smallCenter}
      >
        Inquire about expedited service levels for higher valued cards.
        <br />
        Prices and turnaround times subject to change.
        <br />
        Email <a href={`mailto:${contactEmail}`}>{contactEmail}</a> with any
        questions or concerns
      </Typography>
    </>
  );
};
